<div
  [matTooltip]="tooltipText === '' ? null : tooltipText"
  matTooltipPosition="right"
  matTooltipClass="multiline-tooltip"
  class="max-w-max"
>
  {{ displayText }}
</div>
